import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Link2, Paperclip, ScanSearch, Loader2 } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";
import { CidAnalysisResult } from "@/components/templates/CidAnalysisResult";

const OPTIONS = [
  {
    value: "external", icon: Link2, title: "Externas (URL)",
    desc: "Las imágenes se cargan desde su URL pública. Correo más liviano, pero algunos destinatarios externos las bloquean hasta que pulsan \"Descargar imágenes\".",
  },
  {
    value: "cid", icon: Paperclip, title: "CID (embebidas)",
    desc: "El servidor descarga cada imagen y la adjunta en línea (cid:). Se ven siempre, sin bloqueo. Los iconos SVG se convierten a PNG automáticamente.",
  },
];

export function ImageStrategyCard({ value, onChange, analysis, analyzing, onAnalyze }) {
  return (
    <Card className="p-5 border-slate-200 shadow-sm" data-testid={TEMPLATES.imageStrategyCard}>
      <div className="flex items-center gap-2 mb-3">
        <Paperclip className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
        <h3 className="text-sm font-semibold text-slate-900">Estrategia de imágenes</h3>
      </div>
      <RadioGroup value={value} onValueChange={onChange} className="gap-2">
        {OPTIONS.map(({ value: v, icon: Icon, title, desc }) => (
          <label key={v} htmlFor={`img-strategy-${v}`}
            className={`flex gap-3 p-3 rounded-md border cursor-pointer transition-colors ${value === v ? "border-orange-400 bg-orange-50/60" : "border-slate-200 hover:border-orange-200 hover:bg-slate-50"}`}
            data-testid={TEMPLATES.imageStrategyOption(v)}>
            <RadioGroupItem id={`img-strategy-${v}`} value={v}
              className="mt-0.5 border-orange-500 text-orange-600" />
            <div className="min-w-0">
              <div className="flex items-center gap-1.5 text-sm font-medium text-slate-900">
                <Icon className="w-3.5 h-3.5 text-slate-500" strokeWidth={1.75} /> {title}
              </div>
              <p className="text-[11px] text-slate-500 leading-relaxed mt-0.5">{desc}</p>
            </div>
          </label>
        ))}
      </RadioGroup>
      {value === "cid" && (
        <div className="mt-3 pt-3 border-t border-slate-100 space-y-3">
          <Button size="sm" variant="outline" onClick={onAnalyze} disabled={analyzing}
            className="h-7 text-xs border-slate-200 hover:bg-orange-50 hover:text-orange-700 hover:border-orange-200"
            data-testid={TEMPLATES.cidAnalyzeBtn}>
            {analyzing
              ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" strokeWidth={1.75} />
              : <ScanSearch className="w-3.5 h-3.5 mr-1" strokeWidth={1.75} />}
            Analizar imágenes
          </Button>
          {analysis && <CidAnalysisResult analysis={analysis} />}
        </div>
      )}
    </Card>
  );
}
